import React, { useRef, useState, useEffect } from "react";
import { Formik, Field } from "formik";
import { Row, Col, FormGroup, InputGroup, Input, Label, Button } from "reactstrap";
import FormikRadioboxField from "../../../components/common/Fields/FormikRadioboxField"
import { cloneDeep } from 'lodash';
import FormikSelectField from "../../../components/common/Fields/FormikSelectField";
import useAxios from "../../../hooks/useAxios";
import FormikInputField from "../../../components/common/Fields/FormikInputField";
import reset from "../../../assets/icon/reset.svg";
import search from "../../../assets/icon/search.svg";




let planoptions = [];
let stateoptions = [];
let countyoptions = [];
let zipcodeoptions = [];

    let initialFilters = {
  state: "",
  City: "",
  ZipCode:"",
  pharmacyName:"",
};

const SearchContainerNetwork = ({selectedlocation,islocdenied,selectedRadio,
onReset,states,onSearch,ZipCodes

}) => {
    const API = useAxios();
    const [state, setState] = useState([]);
    const [county, setCounty] = useState([]);
    //const [zipCode, setZipCode] = useState([]);
    const [plan, setPlan] = useState([]);
     const [selectedValue, setSelectedValue] = useState("currentLocation");
    const [stateCode, setstateCode] = useState('');
    const [ZipCode, setZipCode] = useState('');
     const [City, setCity] = useState('');
    const [PhName, setPharmacyName] = useState('');
    const [locations, setLocations] = useState([]);
    const[selectedState,setSelectedState]=useState("");
        const [errors, setErrors] = useState('');
        const[zipisvalid,SetZipIsValid]=useState(false);
  

const handleStateChange=(e,setFieldValue)=>{
  setZipCode("");   
  setFieldValue('ZipCode',"")
  setSelectedState(e.target.value);
  const value=e.target.value;
   setFieldValue('state', value)
}

const handleZipCodeChange=(e,setFieldValue)=>{
     setZipCode(e.target.value);
if (/^\d{5,}$/.test(e.target.value)) {
      setFieldValue('ZipCode',ZipCode)
      SetZipIsValid(true);
}
      else{
        SetZipIsValid(false);
      }
  setSelectedState("");
  setFieldValue('state', "")
}

     const handleRadioChange = (key) => (event) => {
      SetZipIsValid(false);
        setSelectedState("")
        setZipCode("")
        setCity("")
        setPharmacyName("")
        setSelectedValue(key);
        selectedlocation(key);
        
    };

  const handleSubmit = async (val, actions) => {
        if ( !ZipCode  && selectedState == "" ) {
            setErrors(true)
        }
        else {
            const { setSubmitting } = actions;
            const values = cloneDeep(val);
            // values.plan = val.plan
            values.state = selectedState;
            values.City=City;
            values.ZipCode=ZipCode;
            values.pharmacyName=PhName
            await onSearch(values);
            setSubmitting(false);
            setErrors(false)
        }
    };

    const handleReset=()=>{
          setSelectedState("")
        setZipCode("")
        SetZipIsValid(false);
        setCity("")
        setPharmacyName("")
      onReset();
    }

   
    return (
        <>
            <Formik
                onSubmit={handleSubmit}
                initialValues={initialFilters}
                children={(props) => {
                    const { handleSubmit, setFieldValue } = props;
                    return (

                        <div >
                               {/* <h5 className="f-15 text-primary font-weight-700">
                                Pharmacy Directory Search
                            </h5> */}
                           <Row xs={3}>


                            <Row>        <Col xs={1} ><InputGroup>
                                    <Input
                                        name="currentLocation"
                                        type="radio"
                                        className=""
                                        component={FormikRadioboxField}
                                        // value="CurrentLocation"
                                        checked={selectedRadio === 'currentLocation'}
                                        disabled={islocdenied === "Y"}
                                        onChange={handleRadioChange("currentLocation")}
                                    ></Input>

                                </InputGroup></Col>
                                <Col><Label for="currentLocation">Use current location</Label></Col>
                            </Row>

                        <Col>
                            <Row >
                                <Col xs={1} ><InputGroup>
                                    <Input
                                        name="ZIP"
                                        type="radio"
                                        //  className="custom-checkbox"
                                        component={FormikRadioboxField}
                                        checked={selectedRadio === 'ZIP'}
                                        onChange={handleRadioChange("ZIP")}
                                    ></Input>
                                </InputGroup></Col>
                                <Col><Label for="ZIP">Zip code</Label></Col>
                            </Row>
                        </Col>
                        <Col>
                            <Row>
                                <Col xs={1}><InputGroup>
                                    <Input
                                        name="cityState"
                                        type="radio"
                                        // className="custom-checkbox"
                                        component={FormikRadioboxField}
                                        checked={selectedRadio === 'CityState'}
                                        onChange={handleRadioChange("CityState")}
                                    ></Input>
                                </InputGroup></Col>
                                <Col><Label for="cityState">State</Label></Col>
                            </Row>
                        </Col>
                    </Row>




 {selectedRadio === 'ZIP'  && (
    <div>
    <Row className="mb-4 justify-content-center">
    <Col sm={3} className="">
      <Label > Zip code</Label>
  
            <Field
            name="ZipCode"
            className="required"
            value={ZipCode}
            component={FormikInputField}
            placeholder="Enter Zip code"
            onChange={(e)=>
           handleZipCodeChange(e,setFieldValue)
            }
           >
            </Field>

                 {/* <Field
                                        id="ZipCode"
                                            name="ZipCode"
                                            component={FormikSelectField}
                                            options={ZipCodes}
                                            defaultoption="--Select Zip--"
                                            value={ZipCode}
                                            className="required "
                                            keys={{
                                                id: 'id',
                                                label: 'label',
                                            }}

                                          onChange={(e)=>{handleZipCodeChange(e,setFieldValue)}}
                                        /> */}
          
    </Col>
     <Col sm={3} className="">
      <Label> Pharmacy Name</Label>
       <Field
       name="pharmacyName"
       disabled={!zipisvalid}
      value={PhName}
       component={FormikInputField}
      placeholder="Enter Pharmacy Name"
      onChange={(e)=>{
        const value=e.target.value;
         setPharmacyName(e.target.value)
        setFieldValue(PhName);
       }
        }>
       </Field>
 </Col>


  </Row>
  
         

     </div>
      )}

      {selectedRadio === 'CityState' && (
    <div>

<Row sm={3} className="mb-4 justify-content-center ">
   <Col sm={3} className="">
        <Label for="stateid">State</Label>
        <Formik>
                                        <Field
                                        id="state"
                                            name="state"
                                            component={FormikSelectField}
                                            options={states}
                                            defaultoption="--Select State--"
                                            value={selectedState}
                                            className="required "
                                            keys={{
                                                id: 'id',
                                                label: 'label',
                                            }}

                                          onChange={(e)=>{handleStateChange(e,setFieldValue)}}
                                        />

             </Formik>

    </Col>
    <Col sm={3} className="">
      <Label>City</Label>
      <Field
      name="City"
      value={City}
        disabled={!selectedState}
      component={FormikInputField}
          placeholder="Enter City"
      onChange={(e)=>{
          const value=e.target.value;
          setCity(e.target.value)
          setFieldValue(City);
    }
        }>
      </Field>
      
    </Col>
    <Col sm={3} className="">
      <Label> Pharmacy Name</Label>
       <Field
       name="pharmacyName"
      value={PhName}
        disabled={!selectedState}
      component={FormikInputField}
       placeholder="Enter Pharmacy Name"
      onChange={(e)=>{
          const value=e.target.value;
           setPharmacyName(e.target.value)
          setFieldValue(PhName);
       }
        }>
       </Field>
 </Col>

    
  </Row>


         


   


     </div>
      )}
      { selectedRadio !='currentLocation' &&
       <Row className="d-flex" style={{ justifyContent: "flex-end" }}>
              <Col md="auto" className="">
                <Label>{""}</Label>
                <Button
                  onClick={handleSubmit}
                  color="primary"
                  className="search ms-3"
                  disabled={(selectedRadio ==="ZIP"  &&  zipisvalid==false)  || (selectedRadio ==="CityState" && !selectedState)}
                >
                  <span className="right_5">
                    <img src={search} alt="" />
                  </span>{" "}
                  Search
                </Button>
                <Button
                  color="primary"
                  className="reset"
                  onClick={() => handleReset(props)}
                >
                  <span className="right_5">
                    <img src={reset} alt="" />
                  </span>{" "}
                  Reset
                </Button>
              </Col>
            </Row>

      }
                    </div>





                    );
                }}
            ></Formik>
        </>
    );
};

export default SearchContainerNetwork;

